// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  MdCheck, MdClose, MdError, MdWarning,
} from 'react-icons/lib/md';
import { CSSTransition } from 'react-transition-group';

import * as actions from '../../../actions/temporaryEvents';
import * as fromTemporaryEvents from '../../../reducers/temporaryEvents';
import * as selectors from '../../../reducers';

import styles from './bannerMessage.css';


type BannerMessagePropTypes = {
  isActive: boolean,
  message: string,
  type: number,
  onClose?: Function,
};

type BannerMessageStateType = {
  hasLoaded: boolean,
}

const TYPES = {
  0: 'default',
  1: 'success',
  2: 'warning',
  '-1': 'error',
};

class BannerMessage extends Component<BannerMessagePropTypes, BannerMessageStateType> {
  constructor(props) {
    super(props);

    this.state = {
      hasLoaded: false,
    };
  }

  componentDidMount() {
    this.setState({
      hasLoaded: true,
    });
  }

  render() {
    const {
      message,
      type,
      onClose,
      isActive = true,
    } = this.props;
    const { hasLoaded } = this.state;

    let Icon = MdCheck;

    switch (type) {
      case -1: {
        Icon = MdError;
        break;
      }
      case 0: {
        Icon = MdWarning;
        break;
      }
      case 2: {
        Icon = MdWarning;
        break;
      }
      default: {
        Icon = MdCheck;
        break;
      }
    }

    return (
      <CSSTransition
        in={hasLoaded && isActive}
        timeout={1000}
        classNames={styles}
        unmountOnExit
      >
        <div className={`
          ${styles.container}
          ${styles[TYPES[type]]}
          ${styles.active}
        `}
        >
          <Icon
            className={styles.icon}
            size="27px"
            color="white"
          />
          <h1>{message}</h1>
          <MdClose
            className={`
              ${styles.icon}
              ${styles.close}  
            `}
            onClick={onClose}
            size="27px"
            color="white"
          />
        </div>
      </CSSTransition>
    );
  }
}


export default connect(
  (state, { id }) => ({
    isActive: fromTemporaryEvents.isActive(selectors.getTemporaryEvent(state, id)),
  }),
  (dispatch, { id }) => ({
    onClose() {
      dispatch(actions.cancel(id));
    },
  }),
)(BannerMessage);



// WEBPACK FOOTER //
// ./src/scripts/components/TemporalBanner/BannerMessage/index.jsx